var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#E0E3E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.626 20L24.5802 25.5964C24.8601 25.8595 25 26.1943 25 26.6009C25 27.0075 24.8601 27.3423 24.5802 27.6054C24.3003 27.8685 23.944 28 23.5115 28C23.0789 28 22.7227 27.8685 22.4428 27.6054L15.4199 21.0045C15.2672 20.861 15.1593 20.7055 15.0962 20.5381C15.0331 20.3707 15.001 20.1913 15 20C14.999 19.8087 15.0311 19.6293 15.0962 19.4619C15.1613 19.2945 15.2692 19.139 15.4199 18.9955L22.4428 12.3946C22.7227 12.1315 23.0789 12 23.5115 12C23.944 12 24.3003 12.1315 24.5802 12.3946C24.8601 12.6577 25 12.9925 25 13.3991C25 13.8057 24.8601 14.1405 24.5802 14.4036L18.626 20Z",
    fill: "#2D2F32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowButton);
export default __webpack_public_path__ + "static/media/arrow-button.04a02c9ff5c0aa07e4e1ba7e21eff5b2.svg";
export { ForwardRef as ReactComponent };